import { Center, Loader } from '@mantine/core';
import { type FC } from 'react';
import classes from './PageSpinner.module.css';

// DL Fork: show a neutral, logo-free loading ring.
const PageSpinner: FC = () => (
    <Center
        data-testid="page-spinner"
        pos="absolute"
        left={0}
        top={0}
        right={0}
        bottom={0}
    >
        <Loader
            className={classes.loader}
            color="ldGray.6"
            size={100}
            type="oval"
        />
    </Center>
);

export default PageSpinner;
